import { useCallback, useState } from "react";
import showToast from "../utils/toastNotifications";

const useFirebaseFileDownload = () => {
    const [isDownloading, setIsDownloading] = useState(false);

    const downloadFileFromFirebase = useCallback(async (fileUrl, customFileName = null) => {
        setIsDownloading(true);

        try {

            const response = await fetch(fileUrl);
            const blob = await response.blob();

            // Create filename
            const filename = customFileName ||
                decodeURIComponent(fileUrl.split('/').pop().split('?')[0]).replace(/^\d+/, '') ||
                'download';

            // Create temporary URL and download
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = filename;

            document.body.appendChild(a);
            a.click();

            // Cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            showToast("success", "Download completed!");
            return { success: true };

        } catch (error) {

            const link = document.createElement('a');
            link.href = fileUrl;
            link.target = '_blank';
            link.click();

            showToast("info", "File opened in new tab. Please save manually.");
            return { success: true, manual: true };
        } finally {
            setIsDownloading(false);
        }
    }, []);

    return {
        downloadFileFromFirebase,
        isDownloading
    };
};

export default useFirebaseFileDownload;